export default "/view/img/4bf4cc668454aed7ae91fb0d9fbd32b1.png";